import { useQuery } from "@tanstack/react-query";
import { fetchTestTasks } from "../services/api";
import { TestTask } from "../constants/AllTypes";
  
  export const useTestTasks = (lessonId: number, studentId: number, attempt: number, checkingResult: boolean) => {
    return useQuery({
      queryKey: ['testTasks', lessonId, studentId, attempt],
      enabled: !!lessonId && !!studentId && !!checkingResult,
      queryFn: async () => {
        if (!lessonId || !studentId) return null;
  
        const localKey = `testTasks_${lessonId}_${studentId}_${attempt}`;

        const readLocal = (): TestTask[] => {
          try {
            const stored = localStorage.getItem(localKey);
            const parsed = stored ? JSON.parse(stored) : null;
            return Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            console.error('Error parsing test tasks from localStorage:', error);
            return [];
          }
        };

        // --- Backend first, so teacher grading and retakes show up ---
        try {
          const testResponse = await fetchTestTasks(lessonId, studentId, Number(attempt));
          const serverTasks: TestTask[] = testResponse?.testTasks || [];

          if (serverTasks.length > 0) {
            // Refresh the local copy (overwrites anything stale)
            localStorage.setItem(localKey, JSON.stringify(serverTasks));
            return serverTasks;
          }
          // Reachable but nothing recorded (e.g. attempts exceeded, marked
          // locally only) — use the local copy if there is one.
          return readLocal();
        } catch (error) {
          // --- Offline / server error: fall back to the local copy ---
          console.error('Error fetching test tasks:', error);
          return readLocal();
        }
      },
    });
  };